/* usage: snippets/product-modal-quick-add.liquid */

 document.addEventListener("DOMContentLoaded", function () {
  assignListener(); 

   let observer = new MutationObserver( mutations=>{
    assignListener();
   } );

   observer.observe( document.querySelector("#facets-results"),{
      subtree: true,
      childList: true
   } );

   function assignListener(){
    const items = document.querySelectorAll('[data-js-product-item]');

    if(items.length === 0){
        return console.log("Can't find collectionitems")
    }

    items.forEach(item => {
      item.addEventListener('click', openDialog)
    })
   }

   

   function openDialog(e){

      // Prevent default if the element doesn't belong to the collection section
      if(!document.querySelector("#facets-results")){
        e.preventDefault(); 
      }

     const productId = e.currentTarget.dataset.jsProductId

     const modal = document.querySelector(`[data-modal-item="${productId}"]`)

     if(!modal){
       return console.log("Cant find modal for id: " + productId)
     }
     //console.log(modal)

     modal.showModal()

     closeModal(productId, modal)
     bindQuantity(productId, modal)

      // modal backdrop
      modal.addEventListener("click", (e)=> {
        if(e.target.nodeName === "DIALOG"){
            modal.close()
        }	
      })

   }

   function closeModal(productId, modal){
    const closeBtn = document.querySelector(`[data-modal-item="${productId}"] button`)
    if(!closeBtn){
     return console.log("Cant find modal close button")
   }
     
    closeBtn.addEventListener("click", ()=> {
      modal.setAttribute("data-closing", "")
      modal.addEventListener("animationend", ()=>{
          modal.removeAttribute("data-closing")
          modal.close()
      }, {once: true})	
    })
   }

   function bindQuantity(productId, modal){
     const increment = document.querySelector(`[data-modal-item="${productId}"] [data-js-qty-inc]`)
     const decrement = document.querySelector(`[data-modal-item="${productId}"] [data-js-qty-dec]`)
     

     if( !increment || !decrement){
       return console.log('Cant find qty modal elements')
     }
     increment.addEventListener('click', () => handleQty(productId, 'inc'))
     decrement.addEventListener('click', () => handleQty(productId, 'dec'))
   }

   function handleQty(productId, type){
    const input =  document.querySelector(`[data-modal-item="${productId}"] [data-js-qty]`)
     if(!input ){
       return console.log('Cant find qty modal elements')
   }
     console.log(input)
     
     if(type === 'inc'){
       const total = Number(input.value)
       //console.log(total)
       input.value = total + 1
       return
     }
     
     if(type === 'dec'){
       const current = Number(input.value)
       const total = current <= 0 ? 1  : current - 1
       input.value = total
       return
     }
     
   }
   
})
